import fonts from './fonts'
import breakpoints from './breakpoints'
import colors from './colors'
import textStyles from './textStyles'
import sizes from './sizes'

const theme = {
  colors,
  fonts,
  breakpoints,
  textStyles,
  sizes,
}

export default theme
